/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconTent = createReactComponent("outline", "tent", "IconTent", [["path", { "d": "M11 14l4 6h6l-9 -16l-9 16h6l4 -6", "key": "svg-0" }]]);

export { IconTent as default };
//# sourceMappingURL=IconTent.mjs.map
